'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import tkns from '@lualtek/tokens/web/tokens.json';
import clsx from 'clsx';
import { forwardRef, useMemo, } from 'react';
import styles from './badge.module.css';
export const Badge = forwardRef(({ children, className, gap = 4, badgeSize = 12, color = 'yellow', style, showBadge = false, ...otherProps }, forwardRef) => {
    const dynamicStyle = useMemo(() => ({
        '--badge-size': `${badgeSize}px`,
        '--gap': `${gap}px`,
        '--badge-color': tkns.color[color]['50'],
    }), [badgeSize, gap, color]);
    return (_jsx("div", { ref: forwardRef, className: clsx(styles.Badge, className), "data-badge-show": showBadge, style: { ...dynamicStyle, ...style }, ...otherProps, children: _jsx("div", { className: styles.Mask, children: children }) }));
});
